<template>
  <div class="graficoalmacen">
    <div class="panel panel-flat">
      <div class="panel-body" style="text-align: center;">
        <span style="font-weight: 700; font-size: 16px; font-family: arial;">Transporte</span>
        <!-- Porcentje & envios -->
        <div class="row">
          <div class="col-lg-6">
            <JqxChart
              style="width: 100%; height: 300px"
              :title="'Porcentaje de envios a tiempo'"
              :description="''"
              :showLegend="true"
              :enableAnimations="true"
              :padding="padding"
              :titlePadding="titlePadding"
              :source="data5"
              :showToolTips="true"
              :seriesGroups="seriesGroups2"
              :colorScheme="'scheme05'"
              :backgroundColor="'#FAFAFA'"
            ></JqxChart>
          </div>
          <div class="col-lg-6">
            <JqxChart
              style="width: 100%; height: 300px"
              ref="donutEnviosTransportista"
              :title="'Envíos por compañía'"
              :description="''"
              :showLegend="true"
              :enableAnimations="true"
              :padding="padding"
              :titlePadding="titlePadding"
              :source="dataDET"
              :showToolTips="true"
              :seriesGroups="seriesGroupsET"
              :colorScheme="'scheme01'"
              :backgroundColor="'#FAFAFA'"
              :showBorderLine="true"
            ></JqxChart>
          </div>
        </div>
        <br />
        <!-- Mapas -->
        <div class="row">
          <div class="col-lg-6">
            <span style="font-weight: 700; font-size: 16px; font-family: arial;">Origen</span>
            <vl-map
              :load-tiles-while-animating="true"
              :load-tiles-while-interacting="true"
              data-projection="EPSG:4326"
              style="height: 335px; padding-top: 10px;"
            >
              <!-- Mav view -->
              <vl-view :zoom.sync="zoom" :center.sync="center" :rotation.sync="rotation"></vl-view>
              <!-- /Mav view -->

              <!-- Map tile -->
              <vl-layer-tile id="bingmaps">
                <vl-source-bingmaps :api-key="apiKey" :imagery-set="imagerySet" :culture="culture"></vl-source-bingmaps>
              </vl-layer-tile>
              <!-- /Map tile -->

              <!-- Circulos -->
              <vl-feature v-for="ciudad in ciudadesOrigen" :key="ciudad.prov" :id="ciudad.ciudad">
                <vl-geom-circle :radius="ciudad.total" :coordinates="ciudad.coor"></vl-geom-circle>
                <vl-style-box>
                  <vl-style-stroke color="#359B35"></vl-style-stroke>
                  <vl-style-fill color="#5AE45AAB"></vl-style-fill>
                  <vl-style-text :text="String(ciudad.total)"></vl-style-text>
                </vl-style-box>
              </vl-feature>
              <!-- /Circulos -->

              <!-- interactions -->
              <vl-interaction-select :features.sync="selectedFeatures">
                <template slot-scope="select">
                  <!-- select styles -->
                  <vl-style-box>
                    <vl-style-stroke color="#423e9e" :width="7"></vl-style-stroke>
                    <vl-style-fill :color="[254, 178, 76, 0.7]"></vl-style-fill>
                    <vl-style-circle :radius="5">
                      <vl-style-stroke color="#423e9e" :width="7"></vl-style-stroke>
                      <vl-style-fill :color="[254, 178, 76, 0.7]"></vl-style-fill>
                    </vl-style-circle>
                  </vl-style-box>
                  <vl-style-box :z-index="1">
                    <vl-style-stroke color="#d43f45" :width="2"></vl-style-stroke>
                    <vl-style-circle :radius="5">
                      <vl-style-stroke color="#d43f45" :width="2"></vl-style-stroke>
                    </vl-style-circle>
                  </vl-style-box>
                  <!--// select styles -->

                  <!-- selected feature popup -->
                  <vl-overlay
                    class="feature-popup"
                    v-for="feature in select.features"
                    :key="feature.id"
                    :id="feature.id"
                    :position="pointOnSurface(feature.geometry)"
                    :auto-pan="true"
                    :auto-pan-animation="{ duration: 300 }"
                  >
                    <template>
                      <section class="card">
                        <header class="card-header">
                          <div class="row">
                            <div class="col-lg-1">
                              <div style="padding-top: 9px; padding-left: 5px;">
                                <a
                                  class="card-header-icon"
                                  title="Cerrar"
                                  @click="selectedFeatures = selectedFeatures.filter(f => f.id !== feature.id)"
                                >
                                  <span class="glyphicon glyphicon-remove"></span>
                                </a>
                              </div>
                            </div>
                            <div class="col-lg-11">
                              <span
                                class="card-header-title"
                              >{{ `${ciudadseleccionada.ciudad} (${ciudadseleccionada.prov})` }}</span>
                            </div>
                          </div>
                        </header>
                        <div class="card-content">
                          <div class>
                            <span>{{ `Envíos ${ciudadseleccionada.total}` }}</span>
                          </div>
                        </div>
                      </section>
                    </template>
                  </vl-overlay>
                  <!--// selected popup -->
                </template>
              </vl-interaction-select>
              <!--// interactions -->
            </vl-map>
          </div>
          <div class="col-lg-6">
            <span style="font-weight: 700; font-size: 16px; font-family: arial;">Destino</span>
            <vl-map
              :load-tiles-while-animating="true"
              :load-tiles-while-interacting="true"
              data-projection="EPSG:4326"
              style="height: 335px; padding-top: 10px;"
            >
              <!-- Mav view -->
              <vl-view :zoom.sync="zoom2" :center.sync="center2" :rotation.sync="rotation2"></vl-view>
              <!-- /Mav view -->

              <!-- Map tile -->
              <vl-layer-tile id="bingmaps">
                <vl-source-bingmaps :api-key="apiKey" :imagery-set="imagerySet" :culture="culture"></vl-source-bingmaps>
              </vl-layer-tile>
              <!-- /Map tile -->

              <!-- Circulos -->
              <vl-feature v-for="ciudad in ciudadesDestino" :key="ciudad.prov" :id="ciudad.ciudad">
                <vl-geom-circle :radius="ciudad.total" :coordinates="ciudad.coor"></vl-geom-circle>
                <vl-style-box>
                  <vl-style-stroke color="#359B35"></vl-style-stroke>
                  <vl-style-fill color="#5AE45AAB"></vl-style-fill>
                  <vl-style-text :text="String(ciudad.total)"></vl-style-text>
                </vl-style-box>
              </vl-feature>
              <!-- /Circulos -->

              <!-- interactions -->
              <vl-interaction-select :features.sync="selectedFeatures2">
                <template slot-scope="select">
                  <!-- select styles -->
                  <vl-style-box>
                    <vl-style-stroke color="#423e9e" :width="7"></vl-style-stroke>
                    <vl-style-fill :color="[254, 178, 76, 0.7]"></vl-style-fill>
                    <vl-style-circle :radius="5">
                      <vl-style-stroke color="#423e9e" :width="7"></vl-style-stroke>
                      <vl-style-fill :color="[254, 178, 76, 0.7]"></vl-style-fill>
                    </vl-style-circle>
                  </vl-style-box>
                  <vl-style-box :z-index="1">
                    <vl-style-stroke color="#d43f45" :width="2"></vl-style-stroke>
                    <vl-style-circle :radius="5">
                      <vl-style-stroke color="#d43f45" :width="2"></vl-style-stroke>
                    </vl-style-circle>
                  </vl-style-box>
                  <!--// select styles -->

                  <!-- selected feature popup -->
                  <vl-overlay
                    class="feature-popup"
                    v-for="feature in select.features"
                    :key="feature.id"
                    :id="feature.id"
                    :position="pointOnSurface(feature.geometry)"
                    :auto-pan="true"
                    :auto-pan-animation="{ duration: 300 }"
                  >
                    <template>
                      <section class="card">
                        <header class="card-header">
                          <div class="row">
                            <div class="col-lg-1">
                              <div style="padding-top: 9px; padding-left: 5px;">
                                <a
                                  class="card-header-icon"
                                  title="Cerrar"
                                  @click="selectedFeatures2 = selectedFeatures2.filter(f => f.id !== feature.id)"
                                >
                                  <span class="glyphicon glyphicon-remove"></span>
                                </a>
                              </div>
                            </div>
                            <div class="col-lg-11">
                              <span
                                class="card-header-title"
                              >{{ `${ciudadseleccionada2.ciudad} (${ciudadseleccionada2.prov})` }}</span>
                            </div>
                          </div>
                        </header>
                        <div class="card-content">
                          <div class>
                            <span>{{ `Recepciones ${ciudadseleccionada2.total}` }}</span>
                          </div>
                        </div>
                      </section>
                    </template>
                  </vl-overlay>
                  <!--// selected popup -->
                </template>
              </vl-interaction-select>
              <!--// interactions -->
            </vl-map>
          </div>
        </div>
        <!-- /Mapas -->
        <!-- Numero origen-destino -->
        <div class="row">
          <div class="col-lg-12">
            <JqxChart
              style="width: 100%; height: 500px"
              :title="'Grupos de Envíos'"
              :description="'Total de origen destino por Ciudades'"
              :showLegend="true"
              :enableAnimations="true"
              :padding="padding"
              :enableCrosshairs="true"
              :titlePadding="titlePadding"
              :source="dataOD"
              :xAxis="xAxis"
              :valueAxis="valueAxisOD"
              :seriesGroups="seriesGroupsOD"
              :colorScheme="'scheme05'"
            ></JqxChart>
          </div>
        </div>
        <!-- Numero origen-destino -->
      </div>
    </div>
  </div>
</template>
<script>
import JqxChart from "jqwidgets-scripts/jqwidgets-vue/vue_jqxchart.vue";
import { findPointOnSurface } from "vuelayers/lib/ol-ext";
import es_ciudades from "@/assets/data/ciudades/es.json";

export default {
  components: {
    JqxChart
  },
  data() {
    return {
      lang: this.$store.getters.lang,
      data5: [
        { comp: "FedEx", porc: 43 },
        { comp: "Correos", porc: 78 },
        { comp: "Seur", porc: 95 },
        { comp: "Ups", porc: 23 }
      ],
      seriesGroups2: [
        {
          type: "column",
          useGradient: false,
          useGradientColors: false,
          valueAxis: {
            unitInterval: 25,
            maxValue: 100,
            minValue: 0,
            labels: { horizontalAlignment: "right" }
          },
          toolTipFormatSettings: { sufix: " %" },
          series: [
            {
              dataField: "porc",
              displayText: "Porcentaje",
              colorFunction: value => {
                return value < this.porcentajeMinimo ? "#CC1133" : "#55CC55";
              }
            }
          ],
          xAxis: {
            dataField: "comp",
            unitInterval: 1,
            textRotationAngle: -75,
            formatFunction: value => {
              return value;
            },
            valuesOnTicks: false
          }
        }
      ],
      // Donuts
      dataDET: [
        { text: "FedEx", value: 25610 },
        { text: "Correos", value: 52100 },
        { text: "Seur", value: 2530 },
        { text: "Ups", value: 960 }
      ],
      seriesGroupsET: [
        {
          type: "donut",
          useGradientColors: false,
          series: [
            {
              showLabels: false,
              enableSelection: true,
              displayText: "text",
              dataField: "value",
              labelRadius: 120,
              initialAngle: 90,
              radius: 90,
              innerRadius: 50,
              centerOffset: 0
            }
          ]
        }
      ],
      // /Donuts
      // Map
      zoom: 5,
      center: [-2.38, 40.16],
      rotation: 0,
      zoom2: 5,
      center2: [-2.38, 40.16],
      rotation2: 0,
      apiKey:
        "ArbsA9NX-AZmebC6VyXAnDqjXk6mo2wGCmeYM8EwyDaxKfQhUYyk0jtx6hX5fpMn",
      culture: "es-ES",
      imagerySet: "CanvasGray",
      geolocPosition: undefined,
      selectedFeatures: [],
      selectedFeatures2: [],
      pointOnSurface: findPointOnSurface,
      ciudadseleccionada: {},
      ciudadseleccionada2: {},
      ciudadesOrigen: [
        {
          prov: "Bizcaya",
          ciudad: "Bilbao",
          total: 25300
        },
        {
          prov: "Álava",
          ciudad: "Vitoria-Gasteiz",
          total: 12500
        },
        {
          prov: "Guipuzcoa",
          ciudad: "San Sebastián",
          total: 65500
        },
        {
          prov: "Cuenca",
          ciudad: "Cuenca",
          total: 45620
        },
        {
          prov: "Albacete",
          ciudad: "Albacete",
          total: 2360
        },
        {
          prov: "Almería",
          ciudad: "Almería",
          total: 1200
        }
      ],
      ciudadesDestino: [
        {
          prov: "Barcelona",
          ciudad: "Barcelona",
          total: 25000
        },
        {
          prov: "Córdoba",
          ciudad: "Córdoba",
          total: 125000
        }
      ],
      // /Map
      padding: { left: 5, top: 5, right: 5, bottom: 5 },
      titlePadding: { left: 5, top: 5, right: 5, bottom: 5 },
      porcentajeMinimo: 50
    };
  },
  created() {
    this.completarCoordenadas();
  },
  mounted() {},
  methods: {
    completarCoordenadas() {
      for (let i = 0; i < this.ciudadesOrigen.length; i++) {
        const ciudad = this.ciudadesOrigen[i];
        let ciudadAux = this.findCoordenada(ciudad);
        this.ciudadesOrigen[i] = ciudadAux;
      }
      for (let i = 0; i < this.ciudadesDestino.length; i++) {
        const ciudad = this.ciudadesDestino[i];
        let ciudadAux = this.findCoordenada(ciudad);
        this.ciudadesDestino[i] = ciudadAux;
      }
    },
    findCoordenada(ciudad) {
      for (let j = 0; j < es_ciudades.length; j++) {
        const ciudadAux = es_ciudades[j];
        if (ciudad.ciudad.toLowerCase() === ciudadAux.city.toLowerCase()) {
          ciudad.coor = [Number(ciudadAux.lng), Number(ciudadAux.lat)];
          return ciudad;
        }
      }
    },
    findCiudad(nombre) {
      for (let i = 0; i < this.ciudadesOrigen.length; i++) {
        let ciudad = this.ciudadesOrigen[i];
        if (ciudad.ciudad === nombre) {
          this.ciudadseleccionada = ciudad;
          break;
        }
      }
    },
    findCiudad2(nombre) {
      for (let i = 0; i < this.ciudadesDestino.length; i++) {
        let ciudad = this.ciudadesDestino[i];
        if (ciudad.ciudad === nombre) {
          this.ciudadseleccionada2 = ciudad;
          break;
        }
      }
    }
  },
  watch: {
    selectedFeatures: {
      handler(n, o) {
        if (n !== o && n.length > 0) {
          this.findCiudad(n[0].id);
        }
      },
      deep: true
    },
    selectedFeatures2: {
      handler(n, o) {
        if (n !== o && n.length > 0) {
          this.findCiudad2(n[0].id);
        }
      },
      deep: true
    }
  }
};
</script>

